import type { CriarUnidadeDto, AtualizarUnidadeDto, ConversaoUnidadeResponse, FatorUnidadeResponse, SalvarConversaoDto, UnidadeResponse, UnidadesResponse } from '@triade/contracts';
import { useConsulta, useMutacao } from './base';

/*
 * Unidades de medida e conversoes (por empresa). Leitura com item.ver; gravar com item.editar.
 * Chaves: ['unidades'] cobre a lista e as conversoes (ficam aninhadas em cada unidade).
 */

/** Unidades com as conversoes (GET /unidades): `item.ver`. */
export function useUnidades() {
  return useConsulta<UnidadesResponse>(['unidades'], '/unidades');
}

/** Fator "de -> para" do cadastro, direto ou pelo inverso (GET /unidades/fator): `item.ver`. Sem conversao, fator null. */
export function useFatorUnidade(de: string, para: string) {
  return useConsulta<FatorUnidadeResponse>(['unidades', 'fator', de, para], '/unidades/fator', { query: { de, para }, ativo: de.length > 0 && para.length > 0 });
}

/** Criacao (POST /unidades): `item.editar`. */
export function useCriarUnidade() {
  return useMutacao<UnidadeResponse, CriarUnidadeDto>({
    metodo: 'POST',
    caminho: () => '/unidades',
    corpo: (v) => v,
    invalidar: [['unidades']],
  });
}

/** Alteracao (PATCH /unidades/:id): `item.editar`. Codigo so muda sem itens que usem a unidade (a API decide). */
export function useAtualizarUnidade() {
  return useMutacao<UnidadeResponse, { id: string } & AtualizarUnidadeDto>({
    metodo: 'PATCH',
    caminho: (v) => `/unidades/${v.id}`,
    corpo: ({ id: _id, ...resto }) => resto,
    invalidar: [['unidades']],
  });
}

/** Exclusao (DELETE /unidades/:id): `item.editar`. 409 UNIDADE_EM_USO quando algum item usa a unidade. */
export function useExcluirUnidade() {
  return useMutacao<void, { id: string }>({
    metodo: 'DELETE',
    caminho: (v) => `/unidades/${v.id}`,
    invalidar: [['unidades']],
  });
}

/** Cria ou troca o fator de um par (PUT /unidades/conversoes): `item.editar`. Salvar o mesmo par de novo troca o fator. */
export function useSalvarConversao() {
  return useMutacao<ConversaoUnidadeResponse, SalvarConversaoDto>({
    metodo: 'PUT',
    caminho: () => '/unidades/conversoes',
    corpo: (v) => v,
    invalidar: [['unidades']],
  });
}

/** Exclusao de conversao (DELETE /unidades/conversoes/:id): `item.editar`. */
export function useExcluirConversao() {
  return useMutacao<void, { id: string }>({
    metodo: 'DELETE',
    caminho: (v) => `/unidades/conversoes/${v.id}`,
    invalidar: [['unidades']],
  });
}
